import { Builder } from '@builder.io/react';
import image from '@/assets/images/cms/productSlider.svg?inline';

export interface StaticProductSliderComponentProps {
	readonly title?: string;
	readonly subtitle?: string;
	readonly products: readonly SelectedProduct[];
	readonly hideArrows?: boolean;
}

export interface SelectedProduct {
	readonly id: string;
	readonly segmentId: string;
}

const register = <TProps extends StaticProductSliderComponentProps>(Component: React.FC<TProps>): void => {
	Builder.registerComponent(Component, {
		name: 'StaticProductSlider',
		image,
		inputs: [
			{
				type: 'string',
				name: 'subtitle',
				defaultValue: 'Latest trends',
			},
			{
				type: 'string',
				name: 'title',
				defaultValue: 'See our new arrivals',
			},
			{
				type: 'Bizzkit ECS Product List',
				name: 'products',
			},
			{
				name: 'hideArrows',
				type: 'boolean',
				defaultValue: false,
				friendlyName: 'Hide arrows',
			},
		],
	});
};

export default register;
